"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMenuItemConfiguration = exports.DayOfWeek = void 0;
var casing_1 = require("./casing");
var common_1 = require("./common");
var filtering_1 = require("./filtering");
var lists_1 = require("./lists");
var params_1 = require("./params");
var relatives_1 = require("./relatives");
var hours_1 = require("./hours");
Object.defineProperty(exports, "DayOfWeek", { enumerable: true, get: function () { return hours_1.DayOfWeek; } });
var BaseMenuItemConfiguration = /** @class */ (function () {
    function BaseMenuItemConfiguration(config) {
        this.config = config;
    }
    return BaseMenuItemConfiguration;
}());
exports.BaseMenuItemConfiguration = BaseMenuItemConfiguration;
var MenuItemConfiguration = /** @class */ (function () {
    function MenuItemConfiguration(baseConfiguration, allConfigurations) {
        this._configuration = baseConfiguration.config;
        var defaultValue = {};
        this.allConfigurations = Object.entries(allConfigurations).reduce(function (acc, _a) {
            var _b;
            var _c = __read(_a, 2), collection = _c[0], baseConfig = _c[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[collection] = baseConfig.config, _b)));
        }, defaultValue);
    }
    Object.defineProperty(MenuItemConfiguration.prototype, "defaults", {
        get: function () {
            return (0, params_1.getDefaults)(this._configuration);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "casing", {
        get: function () {
            return (0, casing_1.getCasing)(this._configuration);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "filters", {
        get: function () {
            return (0, filtering_1.getFilters)(this._configuration);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "sortKeys", {
        get: function () {
            return (0, filtering_1.getSortKeys)(this._configuration);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "parents", {
        get: function () {
            return (0, relatives_1.getParents)(this._configuration, this.allConfigurations);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "relations", {
        get: function () {
            return (0, relatives_1.getRelations)(this._configuration, this.allConfigurations);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "lists", {
        get: function () {
            return (0, lists_1.getLists)(this._configuration.lists, this.allConfigurations);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "brandSyncedAttributes", {
        get: function () {
            var _a = this._configuration, sellable = _a.sellable, hasImage = _a.hasImage, hasDescription = _a.hasDescription, hasHours = _a.hasHours, hasVariations = _a.hasVariations, options = _a.options, unlinkedOptions = _a.unlinkedOptions, consumable = _a.consumable;
            var defaultBrandSyncedAttributes = [
                'name',
                'available',
                'availableAt',
                'displayName',
            ];
            if (sellable)
                defaultBrandSyncedAttributes.push('amount', 'taxRate', 'taxable');
            if (hasImage)
                defaultBrandSyncedAttributes.push('image');
            if (hasDescription)
                defaultBrandSyncedAttributes.push('description');
            if (hasHours)
                defaultBrandSyncedAttributes.push('hours');
            if (hasVariations)
                defaultBrandSyncedAttributes.push('variationGroups');
            if (consumable)
                defaultBrandSyncedAttributes.push('allergens', 'alcohol', 'glutenFree', 'vegetarian');
            return (0, common_1.removeDuplicates)(__spreadArray(__spreadArray([], __read(defaultBrandSyncedAttributes), false), __read(Object.keys(options)), false)).filter(function (property) { return !unlinkedOptions.includes(property); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MenuItemConfiguration.prototype, "configuration", {
        get: function () {
            var _a = this._configuration, hasDescription = _a.hasDescription, hasHours = _a.hasHours, hasImage = _a.hasImage, hasVariations = _a.hasVariations, hasPos = _a.hasPos, sellable = _a.sellable, consumable = _a.consumable, options = _a.options, unlinkedOptions = _a.unlinkedOptions, version = _a.version, name = _a.name;
            var _b = this, defaults = _b.defaults, casing = _b.casing, filters = _b.filters, brandSyncedAttributes = _b.brandSyncedAttributes, lists = _b.lists, sortKeys = _b.sortKeys, parents = _b.parents, relations = _b.relations;
            return {
                hasDescription: hasDescription,
                hasHours: hasHours,
                hasImage: hasImage,
                hasVariations: hasVariations,
                hasPos: hasPos,
                sellable: sellable,
                consumable: consumable,
                options: options,
                unlinkedOptions: unlinkedOptions,
                sortKeys: sortKeys,
                version: version,
                casing: casing,
                defaults: defaults,
                filters: filters,
                parents: parents,
                relations: relations,
                lists: lists,
                name: name,
                brandSyncedAttributes: brandSyncedAttributes,
            };
        },
        enumerable: false,
        configurable: true
    });
    return MenuItemConfiguration;
}());
exports.default = MenuItemConfiguration;
//# sourceMappingURL=index.js.map